/**
 * The native-billing-OFF banner: native billing is not turned on for
 * this workspace, so a note marked Ready produces no billable event and
 * no invoice. Tenant-wide and permanent until an owner writes
 * billing.native_from, so it renders ONCE per surface (the Pre-billing
 * tab's head, the Invoices main column), never per row.
 *
 * Pepper-deep on pepper-soft, role="alert": the risk register. Something
 * needs an owner, and the obvious reading of every other line on the
 * surface ("Ready") is wrong without it. Not danger: nothing has been
 * sent to money yet.
 *
 * The copy never says the setting is "missing": the reader nulls a
 * malformed value too, and "not turned on" is true of both.
 */

import type { ReactNode } from 'react';
import { NATIVE_BILLING_OFF_BANNER } from '@/lib/prebilling';

export function NativeBillingOffBanner({ testId }: { testId: string }): ReactNode {
  return (
    <div
      data-testid={testId}
      role="alert"
      className="mb-3 border border-pepper/30 bg-pepper-soft rounded-tight p-3"
    >
      <p className="text-sm text-pepper-deep">{NATIVE_BILLING_OFF_BANNER}</p>
    </div>
  );
}
